import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'winston_site_lang';
const VALID_LANGS = ['fr', 'en', 'vi'];

const SiteLangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        const saved = localStorage.getItem(STORAGE_KEY);
        return VALID_LANGS.includes(saved) ? saved : 'fr';
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, lang);
    }, [lang]);

    const setLang = useCallback((newLang) => {
        if (VALID_LANGS.includes(newLang)) setLangState(newLang);
    }, []);

    const cycleLang = useCallback(() => {
        setLangState(prev => {
            const order = ['fr', 'en', 'vi'];
            const idx = order.indexOf(prev);
            return order[(idx + 1) % order.length];
        });
    }, []);

    return (
        <SiteLangContext.Provider value={{ lang, setLang, cycleLang }}>
            {children}
        </SiteLangContext.Provider>
    );
}

export function useSiteLang() {
    const ctx = useContext(SiteLangContext);
    if (!ctx) {
        throw new Error('useSiteLang doit être utilisé à l\'intérieur de <LangProvider>');
    }
    return ctx;
}